import I18n from 'i18n-js'
import { memo } from 'react'
import { makeStyles } from 'tss-react/mui'

import { formatWithoutCents } from '../../../lib/Utils'
import LegacySvg from '../../shared/LegacySvg'

const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.premiumAds.main,
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 4),
    },
  },
  // Svg doesn't let us control it at all, just a div with a width shoved right
  // in your markup. We need some spacing, so tack it on to the span instead.
  span: {
    display: 'inline-block',
    marginLeft: 10,
    textAlign: 'left',
  },
}))

const PaidAdCredit = (props) => {
  const { classes } = useStyles()

  return (
    <div className={classes.root}>
      <LegacySvg height="20px" symbol="crown" width="20px" />
      <span className={classes.span}>
        {I18n.t('content.premiumAdFunds', {
          amount: formatWithoutCents.format(props.creditAmount / 100),
        })}
      </span>
    </div>
  )
}

export default memo(PaidAdCredit)
